import * as THREE from "three";
// import { TimelineMax } from "gsap";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass";
import { FilmPass } from "three/examples/jsm/postprocessing/FilmPass";
import { UnrealBloomPass } from "three/examples/jsm/postprocessing/UnrealBloomPass";
import fragment from "./shaders/fragment.glsl";
import vertex from "./shaders/vertex.glsl";
import pmaskimg from "./images/particle_mask.jpg";
import t1 from "./images/t1.png";
import t2 from "./images/t2.png";
import t3 from "./images/t3.png";
import t4 from "./images/t4.png";
import t5 from "./images/t5.png";
import modelpath from "./model/model.glb";
// let OrbitalControls = require("three-orbit-controls")(THREE);

export default class Sketch {
  constructor(options) {
    console.log("\x1b[33m%s\x1b[0m" ,"Developed By");
    console.log("\x1b[33m%s\x1b[0m" ,"github.com/pc810");
    this.scene = new THREE.Scene();

    this.container = options.dom;
    this.width = this.container.offsetWidth;
    this.height = this.container.offsetHeight;
    this.renderer = new THREE.WebGLRenderer({
      antialias: true,
    });
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(this.width, this.height);
    // this.renderer.setClearColor(0xffffff, 1);
    this.renderer.setClearColor(0x000000, 1);
    this.renderer.physicallyCorrectLights = true;
    // this.renderer.outputEncoding = THREE.sRGBEncoding;

    this.container.appendChild(this.renderer.domElement);
    this.camera = new THREE.PerspectiveCamera(
      70,
      window.innerWidth / window.innerHeight,
      0.001,
      1000
    );

    this.camera.position.set(0, 0, 1.5);
    // this.controls = new OrbitalControls(this.camera, this.renderer.domElement);
    this.time = 5000;
    this.state = 1;
    this.modelObj = null;
    this.isPlaying = true;
    this.addSpace();
    this.addLight();
    this.addObjects();  
    this.resize();
    this.addPostProcessing();
    this.render();    
    this.setupResize();
  }
  addObjects() {
    const loader = new GLTFLoader();
    let that = this;
    loader.load(
      modelpath,
      function (gltf) {
        let s = 0.07;
        gltf.scene.position.z = 0.1;
        gltf.scene.scale.set(s, s, s);
        that.scene.add(gltf.scene);
        that.modelObj = gltf.scene;
        that.addCharacters();
      },
      undefined,
      function (error) {
        // console.error(error);
      }
    );
  }
  addPostProcessing() {
    this.composer = new EffectComposer(this.renderer);
    this.composer.addPass(new RenderPass(this.scene, this.camera));
    const params = {
      exposure: 0.5,
      bloomStrength: 1,
      bloomThreshold: 0,
      bloomRadius: 0,
    };
    const bloomPass = new UnrealBloomPass(
      new THREE.Vector2(window.innerWidth, window.innerHeight),
      1.5,
      0.1,
      0.85
    );
    bloomPass.threshold = params.bloomThreshold;
    bloomPass.strength = params.bloomStrength;
    bloomPass.radius = params.bloomRadius;
    const filmPass = new FilmPass(0.3,0.4,1000,false);
    this.composer.addPass(bloomPass);
    this.composer.addPass(filmPass);
  }
  addLight() {
    var light = new THREE.HemisphereLight(0xffffff, 0xffffff);
    this.scene.add(light);
  }
  addCharacters() {
    let textureLoader = new THREE.TextureLoader();
    this.textures = [
      textureLoader.load(t1, (t) => {
        t.encoding = THREE.sRGBEncoding;
        t.flipY = false;
      }),
      textureLoader.load(t2, (t) => {
        t.encoding = THREE.sRGBEncoding;
        t.flipY = false;
      }),
      textureLoader.load(t3, (t) => {
        t.encoding = THREE.sRGBEncoding;
        t.flipY = false;
      }),
      textureLoader.load(t4, (t) => {
        t.encoding = THREE.sRGBEncoding;
        t.flipY = false;
      }),
      textureLoader.load(t5, (t) => {
        t.encoding = THREE.sRGBEncoding;
        t.flipY = false;
      }),
    ];
    let that = this;
    if (this.modelObj)
      this.modelObj.traverse(function (child) {
        if (child instanceof THREE.Mesh) {
          child.material.map =
            that.textures[Math.floor(Math.random() * that.textures.length)];
          child.material.needsUpdate = true;
          child.material.map.needsUpdate = true;
        }
      });
    else console.log("error no obj found");
  }
  settings() {
    let that = this;
    this.settings = {
      progress: 0,
    };    
  }
  setupResize() {
    window.addEventListener("resize", this.resize.bind(this));
  }
  resize() {
    this.width = this.container.offsetWidth;
    this.height = this.container.offsetHeight;
    this.renderer.setSize(this.width, this.height);
    this.camera.aspect = this.width / this.height;

    this.imageAspect = 800 / 553;
    let a1;
    let a2;
    if (this.height / this.width > this.imageAspect) {
      a1 = (this.width / this.height) * this.imageAspect;
      a2 = 1;
    } else {
      a1 = 1;
      a2 = (this.height / this.width) * this.imageAspect;
    }

    this.material.uniforms.resolution.value.x = this.width;
    this.material.uniforms.resolution.value.y = this.height;
    this.material.uniforms.resolution.value.z = a1;
    this.material.uniforms.resolution.value.w = a2;
    const dist = this.camera.position.z;
    const height = 0.93;
    this.camera.fov = 2 * (180 / Math.PI) * Math.atan(height / (2 * dist));

    if (this.width / this.height > 1) {
      this.plane.scale.x = this.camera.aspect;
    } else {
      this.plane.scale.y = 1 / this.camera.aspect;
    }
    this.camera.updateProjectionMatrix();
  }
  addSpace() {
    let that = this;
    this.material = new THREE.ShaderMaterial({
      extensions: {
        derivatives: "#extension GL_OES_standard_derivatives : enable",
      },
      side: THREE.DoubleSide,
      uniforms: {
        time: { type: "f", value: 0 },
        texture1: { type: "t", value: null },
        resolution: { type: "v4", value: new THREE.Vector4() },
        maskt: { type: "t", value: new THREE.TextureLoader().load(pmaskimg) },
        uvRate1: {
          value: new THREE.Vector2(1, 1),
        },
      },
      transparent: true,
      vertexShader: vertex,
      fragmentShader: fragment,
    });
    this.geometry = new THREE.PlaneGeometry(1, 2, 3, 3);
    this.plane = new THREE.Points(this.geometry, this.material);

    this.scene.add(this.plane);
  }
  stop() {
    this.isPlaying = false;
  }
  play() {
    if (!this.isPlaying) {
      this.render();
      this.isPlaying = true;
    }
  }
  setAnotherTexture() {
    let that = this;
    this.state = (this.state+1) % this.textures.length;    
    this.modelObj.traverse(function (child) {      
      if (child instanceof THREE.Mesh) {                
        if(that.textures[that.state]){
          // console.log(that.state);
        child.material.map = that.textures[that.state];
        child.material.needsUpdate = true;
        child.material.map.needsUpdate = true;
        }      
      }
    });
  }
  render() {
    if (!this.isPlaying) return;
    this.time += 0.05;
    // if(this.materials){
    //     this.materials.forEach(m=>{
    //         m.uniforms.time.value = this.time;
    //     })
    // }
    if (this.modelObj) {    
      this.modelObj.rotation.z = this.time * 0.05;
      this.modelObj.rotation.x = this.time * 0.05;
      this.modelObj.position.set(((0.01 * this.time) % 1.7) - 0.8, 0, 0.3);            
      if((0.01 * this.time) % 1.7 <= 0.0004){
        // console.log("completed");
        this.setAnotherTexture();
      }
      // console.log((0.01 * this.time) % 1.2)
    }    
    this.material.uniforms.time.value = this.time;
    requestAnimationFrame(this.render.bind(this));
    // this.renderer.render(this.scene, this.camera);
    this.composer.render();

  }
}
